var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_luxon_src_luxon_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react_jsx-runtime_react_jsx-runtime"), __webpack_require__.e("build_node_Chat_js"), __webpack_require__.e("build_node_index_js")]).then(() => (() => ((__webpack_require__("./build/node/index.js")))));
	},
	"./Chat": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_luxon_src_luxon_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react_jsx-runtime_react_jsx-runtime"), __webpack_require__.e("build_node_Chat_js")]).then(() => (() => ((__webpack_require__("./build/node/Chat.js")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});